import React from 'react';

import { NotFoundViewV2 } from '../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function NotFound() {
  return <NotFoundViewV2 />;
}
